import React, { useState } from 'react';
import get from 'lodash/get';
import axios from 'axios';
import {SdfFocusPane, SdfSpotIllustration, SdfBusyIndicator, SdfAlert} from '@synerg/react-components';

export default function GoLiveModal({ projectId, showGoLiveModal, closeGoLiveModal, setIsProdProjectCompleted, reLoadPage }) {
	const [load, setLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	const requestToGoLive = async () => {
		try {
			setLoading(true);
			setErrorMessage('');
			const { data: { success } } = await axios.post(`${import.meta.env.VITE_ROOT_PATH}/api/request-go-live/${projectId}`);
			if (!success) {
				setLoading(false);
				setErrorMessage('Something went wrong.');
				return;
			}
			setIsProdProjectCompleted(true);
			closeGoLiveModal();
			reLoadPage(true);
		} catch (e) {
			setErrorMessage(get(e, 'response.data.message', 'Something went wrong.'));
		}
		setLoading(false);
	}

	return (
		<SdfFocusPane
			visible={showGoLiveModal}
			size='sm'
			acceptLabel='Request to publish'
			closeable={true}
			dismissOnClickOutside={true}
			onSdfDismiss={() => { setErrorMessage(''); closeGoLiveModal(); }}
			onSdfAccept={() => !load ? requestToGoLive() : ''}
			heading='Are you sure?'
		>
			<div className='flex flex-col items-center'>
				{errorMessage && <SdfAlert type='banner' status='error' size='sm' icon='alert-error'>Request failed. Please try again.</SdfAlert>}
				<SdfSpotIllustration className='pt-8' illustrationName='bell' size='lg'></SdfSpotIllustration>
				<p className='w-3/4 text-center text-md leading-md pt-2 pb-12'>By selecting “Request to publish,”  you will notify ADP. Please ensure your integration is ready to go live.</p>
			</div>
		{load && <SdfBusyIndicator size='lg' overlay='true'></SdfBusyIndicator>}
		</SdfFocusPane>
	)
}
